import {useEffect} from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {useNavigate, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";

import Form from "../../components/form/Form";
import { verification } from "../../services/AuthService";
import yup from "../../utils/yup";
import HelperFormButtons from "../../components/HelperFormButtons";

const Verification = () => {
  const [searchParams,] = useSearchParams();
  const navigate = useNavigate();

  const verificationCode = yup
    .object()
    .shape({
      code: yup
        .string("The email or phone number is not valid.")
        .required("The email or phone number is required.")
        .min(8, "The code must be 8 characters long.")
        .max(8, "The code must  be 8 characters long."),
    })
    .required();

  const formDetails = {
    label: "Verify your account",
    submitButtonLabel: "Submit",
    steps: [
      {
        name: "code",
        label: "Verification code",
        type: "text",
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(verificationCode),
    mode: "onChange",
  });

  const additionalFormButtons = [
    {
      label: "Forgot password",
      route: "/reset-password",
    },
    {
      label: "Register",
      route: "/register",
    },
  ];

  useEffect(() => {
    if (searchParams.has('code')) {
      form.setValue('code', searchParams.get('code'));
    }
  }, [searchParams]);

  const handleSubmit = (values) => {
    verification(form.setError)(values).then(async (data) => {
      toast.success('You have successfully verified your account.');
      await window.localStorage.setItem(
        "availabilityTracker",
        JSON.stringify({
          user: data,
          accessTokenExpire: data.access_token_expire,
          refreshTokenExpire: data.refresh_token_expire,
        })
      );

      navigate("/employments");
    })
  }

  return (
    <div>
      <Form
        formDetails={formDetails}
        form={form}
        onSubmit={handleSubmit}
      />
      <Container className="mt-2">
        <Row>
          <HelperFormButtons formButtons={additionalFormButtons} />
        </Row>
      </Container>
    </div>
  );
};

export default Verification;
